import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

export const ClockIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 23 23"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="icon-clock"
        >
            <path
                className={fillStyles}
                d="M11.5 0C17.851 0 23 5.149 23 11.5S17.851 23 11.5 23 0 17.851 0 11.5 5.149 0 11.5 0zm0 1C5.701 1 1 5.701 1 11.5S5.701 22 11.5 22 22 17.299 22 11.5 17.299 1 11.5 1zm0 1.503a.5.5 0 0 1 .5.5V11h6a.5.5 0 1 1 0 1h-7V3.003a.5.5 0 0 1 .5-.5z"
            />
        </svg>
    );
};
